export const LOGIN_MESSAGE = 'LOGIN_MESSAGE'
export const SET_REMEMBER = 'SET_REMEMBER'
export const SET_TOKENS = 'SET_TOKENS'
export const DESTROY_TOKENS = 'DESTROY_TOKENS'
